<template>
  <div class="columns" style="border-top: 1px solid #eee">
    <div class="column is-6">
      <span class="handle">
        <b-icon icon="arrow-all" style="top: 3px; position: relative" />
      </span>
      <router-link
        class="has-text-weight-bold has-margin-left-15"
        :to="{
          name: 'EditWorkout',
          params: {
            eventid: event._id,
            divisionid: division._id,
            id: workout._id,
          },
        }"
        >{{ workout.name }}</router-link
      >
      <br />
      <small
        >{{ workout.type | capitalize }} - {{ workout.format | capitalize }} -
        <strong>Weighting: </strong>{{ workout.weighting }} -
        <strong>Tiebreaker: </strong>
        {{ workout.tiebreaker ? 'Yes' : 'No' }}</small
      >
    </div>
    <div class="column is-2 has-text-warning has-text-weight-bold">
      {{ workout.hide ? 'Hidden' : '' }}
    </div>
    <div class="column is-4 has-text-right">
      <b-dropdown aria-role="list">
        <button slot="trigger" slot-scope="{ active }" class="button is-dark">
          <span>Manage</span>
          <b-icon :icon="active ? 'menu-up' : 'menu-down'"></b-icon>
        </button>

        <b-dropdown-item aria-role="listitem" has-link>
          <router-link
            :to="{
              name: 'EditWorkout',
              params: {
                eventid: event._id,
                divisionid: division._id,
                id: workout._id,
              },
            }"
            >Edit</router-link
          >
        </b-dropdown-item>
        <b-dropdown-item
          v-if="workout.generateheats"
          aria-role="listitem"
          has-link
        >
          <a href="" @click.prevent="generateHeats(workout)">Generate Heats</a>
        </b-dropdown-item>
        <b-dropdown-item
          v-if="workout.generateheats"
          aria-role="listitem"
          has-link
        >
          <router-link
            :to="{
              name: 'ManageHeats',
              params: {
                eventid: event._id,
                divisionid: division._id,
                id: workout._id,
              },
            }"
            >Manage Heats</router-link
          >
        </b-dropdown-item>
        <b-dropdown-item aria-role="listitem" has-link>
          <router-link
            :to="{
              name: event.type === 'online' ? 'ReviewScore' : 'CaptureScore',
              params: {
                eventid: event._id,
                divisionid: division._id,
                id: workout._id,
              },
            }"
            >{{
              event.type === 'online' ? 'Review Scores' : 'Capture Scores'
            }}</router-link
          >
        </b-dropdown-item>
        <b-dropdown-item aria-role="listitem" has-link>
          <a href="" @click.prevent="hideWorkout(workout)">{{
            workout.hide ? 'Unhide' : 'Hide'
          }}</a>
        </b-dropdown-item>
        <b-dropdown-item aria-role="listitem" has-link>
          <a href="" @click.prevent="deleteWorkout(workout)">Delete</a>
        </b-dropdown-item>
        <!-- <b-dropdown-item aria-role="listitem" has-link>
          <a href="" @click.prevent="exportLeaderboard(division)"
            >Export Leaderboard</a
          >
        </b-dropdown-item> -->
      </b-dropdown>
    </div>
  </div>
</template>

<script>
import Filters from '@/mixins/filters'
import EventWorkoutApi from '@/api/event-workout'
import LeaderboardApi from '@/api/leaderboard'

export default {
  name: 'Workout',
  mixins: [Filters],
  props: {
    event: {
      type: Object,
      default: null,
    },
    division: {
      type: Object,
      default: null,
    },
    workout: {
      type: Object,
      default: null,
    },
  },
  methods: {
    async generateHeats() {
      await LeaderboardApi.generateHeats(
        this.event._id,
        this.division.entrytype,
        this.division.category,
        this.division.gender,
        this.workout.name,
        this.workout._id
      )
      this.$buefy.toast.open({
        message: 'Heats generated successfully!',
        position: 'is-top',
        type: 'is-success',
      })
    },
    hideWorkout(entry) {
      entry.hide = !entry.hide
      EventWorkoutApi.updateDivision(this.division)
      this.$buefy.toast.open({
        message: 'Workout updated successfully.',
        position: 'is-top',
        type: 'is-success',
      })
    },
    deleteWorkout(entry) {
      this.$buefy.dialog.confirm({
        message: 'Are you sure you want to delete this workout?',
        onConfirm: async () => {
          this.division.workouts = this.division.workouts.filter(
            (workout) => workout._id !== entry._id
          )
          EventWorkoutApi.updateDivision(this.division)
          this.$buefy.toast.open({
            message: 'Workout deleted.',
            position: 'is-top',
            type: 'is-success',
          })
        },
      })
    },
  },
}
</script>
